import { render, staticRenderFns } from "./AddressSearch.vue?vue&type=template&id=4e5350d7"
import script from "./AddressSearch.vue?vue&type=script&lang=js"
export * from "./AddressSearch.vue?vue&type=script&lang=js"
import style0 from "./AddressSearch.vue?vue&type=style&index=0&id=4e5350d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports